export interface RfwSpaceConfig {
  key: string;
  name: string;
  enabled: boolean;
  description: string;
  format: string;
  avgMonthlyRevenue: number;
}

export interface RfwRevenueShare {
  radio: number;
  rfw: number;
}

export interface RfwHistoryEntry {
  id: number;
  date: string;
  advertiser: string;
  space: string;
  impressions: number;
  clicks: number;
  ctr: number;
  grossRevenue: number;
  radioShare: number;
  rfwShare: number;
}

export interface RfwNetworkConfig {
  participation: boolean;
  spaces: RfwSpaceConfig[];
  revenueShare: RfwRevenueShare;
  totalRadioRevenue: number;
  totalRfwRevenue: number;
  activeCampaigns: number;
  totalImpressions: number;
  monthLabel: string;
  history: RfwHistoryEntry[];
}

export const rfwDefaultSpaces: RfwSpaceConfig[] = [
  {
    key: 'banner-principal',
    name: 'Banner principal',
    enabled: true,
    description: 'Banner 728×90 en el header del sitio. Máxima visibilidad.',
    format: '728×90',
    avgMonthlyRevenue: 900,
  },
  {
    key: 'banner-secundario',
    name: 'Banner secundario',
    enabled: true,
    description: 'Banner 300×250 en sidebar derecho. Alta rotación.',
    format: '300×250',
    avgMonthlyRevenue: 550,
  },
  {
    key: 'patrocinador',
    name: 'Patrocinador',
    enabled: false,
    description: 'Espacio de patrocinio en menciones al aire. 2 por hora.',
    format: 'Audio - Menciones',
    avgMonthlyRevenue: 1200,
  },
  {
    key: 'eventos',
    name: 'Eventos',
    enabled: false,
    description: 'Presencia de marca en eventos organizados por la radio.',
    format: 'Presencial',
    avgMonthlyRevenue: 800,
  },
  {
    key: 'concursos',
    name: 'Concursos',
    enabled: false,
    description: 'Sorteos y concursos con branding del anunciante.',
    format: 'Digital + Aire',
    avgMonthlyRevenue: 650,
  },
];

export const rfwHistory: RfwHistoryEntry[] = [
  { id: 1, date: '2026-06-01', advertiser: 'Movistar', space: 'Banner principal', impressions: 8500, clicks: 340, ctr: 4.0, grossRevenue: 900, radioShare: 540, rfwShare: 360 },
  { id: 2, date: '2026-06-01', advertiser: 'Santander', space: 'Banner secundario', impressions: 6200, clicks: 240, ctr: 3.9, grossRevenue: 550, radioShare: 330, rfwShare: 220 },
  { id: 3, date: '2026-05-15', advertiser: 'Coca-Cola', space: 'Banner principal', impressions: 9200, clicks: 420, ctr: 4.6, grossRevenue: 900, radioShare: 540, rfwShare: 360 },
  { id: 4, date: '2026-05-10', advertiser: 'Claro', space: 'Banner secundario', impressions: 5800, clicks: 210, ctr: 3.6, grossRevenue: 550, radioShare: 330, rfwShare: 220 },
  { id: 5, date: '2026-04-20', advertiser: 'BBVA', space: 'Banner principal', impressions: 7800, clicks: 310, ctr: 4.0, grossRevenue: 900, radioShare: 540, rfwShare: 360 },
  { id: 6, date: '2026-04-05', advertiser: 'Mercado Libre', space: 'Banner secundario', impressions: 5400, clicks: 190, ctr: 3.5, grossRevenue: 550, radioShare: 330, rfwShare: 220 },
];

export const rfwNetworkConfig: RfwNetworkConfig = {
  participation: true,
  spaces: rfwDefaultSpaces,
  revenueShare: { radio: 60, rfw: 40 },
  totalRadioRevenue: 2610,
  totalRfwRevenue: 1740,
  activeCampaigns: 2,
  totalImpressions: 42900,
  monthLabel: 'Junio 2026',
  history: rfwHistory,
};